export enum PaywallVariants {
    default = "default",
    MapV3 = "location_map_v3",
}
